import {Routes} from '@angular/router';
import {MainComponent} from './core/layout/main.component';
import {LoginComponent} from './core/login/login.component';
import {configurazioneRoutes} from './views/configurazione/configurazione.routing';
import {WaitPageComponent} from './core/wait-page/wait-page.component';
import {GrafoFamigliaScreenshotComponent} from './views/famiglia/components/grafo-famiglia-screenshot/grafo-famiglia-screenshot.component';
import {TipoProfilo} from './shared/models';
import {AuthGuard, CanDeactivateGuard} from './core/guards';
import {DynamicDialogConfig, DynamicDialogRef} from 'primeng/dynamicdialog';
import {
	GrafoAziendeScreenshotComponent
} from './views/patrimonio/components/aziendale/grafo-aziende/grafo-aziende-screenshot/grafo-aziende-screenshot.component';

export const routes: Routes = [
	{
		// path di re-login (per servizio KAA) - entra nell'AuthGuard e ridirige subito verso azure
		path: 're-login',
		component: LoginComponent,
		canActivate: [AuthGuard]
	},
	{
		path: '',
		redirectTo: 'applicazioni',
		pathMatch: 'full'
	},
	{
		path: 'login',
		component: LoginComponent
	},
	{
		path: 'login-crm-demo',
		component: LoginComponent
	},
	{
		path: 'screenshot',
		component: GrafoFamigliaScreenshotComponent
	},
  {
    path: 'screenshot/aziende',
    component: GrafoAziendeScreenshotComponent
  },
	{
		path: 'first-login/:uid',
		component: WaitPageComponent
	},
	{
		path: '',
		component: MainComponent,
		canActivate: [AuthGuard],
		children: [
			{
				path: 'applicazioni',
				canActivate: [AuthGuard],
				loadComponent: () => import('./views/applicazioni-dashboard/applicazioni-dashboard.component').then(c => c.ApplicazioniDashboardComponent)
			},
			{
				path: 'applicazioni/:app/dossier',
				loadComponent: () => import('./views/selezione-dossier/selezione-dossier.component').then(c => c.SelezioneDossierComponent),
				canActivate: [AuthGuard],
				data: {authorities: [TipoProfilo.ADMIN, TipoProfilo.CONSULENTE]}
			},
			{
				path: 'applicazioni/:app/funzionalita/famiglia',
				loadComponent: () => import('./views/famiglia/famiglia.component').then(c => c.FamigliaComponent),
				canActivate: [AuthGuard],
				data: {authorities: [], breadcrumb: {label: 'famiglia', icon: 'mdi mdi-family-tree'}}
			},
			{
				path: 'applicazioni/:app/funzionalita/patrimonio',
				loadComponent: () => import('./views/patrimonio/patrimonio.component').then(c => c.PatrimonioComponent),
				canActivate: [AuthGuard],
				canDeactivate: [CanDeactivateGuard],
				data: {authorities: [], breadcrumb: {label: 'patrimonio', icon: 'mdi mdi-bank'}}
			},
			{
				path: 'applicazioni/:app/funzionalita/altre-informazioni',
				loadComponent: () => import('./views/altre-informazioni/altre-informazioni.component').then(c => c.AltreInformazioniComponent),
				canActivate: [AuthGuard],
				canDeactivate: [CanDeactivateGuard],
				data: {authorities: [], breadcrumb: {label: 'altre_informazioni', icon: 'mdi mdi-text-box-search-outline'}}
			},
			{
				path: 'applicazioni/:app/funzionalita/report',
				loadComponent: () => import('./views/report/report.component').then(c => c.ReportComponent),
				canActivate: [AuthGuard],
				canDeactivate: [CanDeactivateGuard],
				data: {authorities: [], breadcrumb: {label: 'report', icon: 'mdi mdi-file-chart'}}
			},
			{
				path: 'applicazioni/:app/funzionalita/analisi',
				loadComponent: () => import('./views/analisi/analisi.component').then(c => c.AnalisiComponent),
				canActivate: [AuthGuard],
				canDeactivate: [CanDeactivateGuard],
				data: {authorities: [], breadcrumb: {label: 'analisi', icon: 'mdi mdi-chart-pie'}}
			},
			{
				path: 'applicazioni/:app/funzionalita/regole',
				loadComponent: () => import('./views/regole/regole.component').then(c => c.RegoleComponent),
				canActivate: [AuthGuard],
				providers: [DynamicDialogRef, DynamicDialogConfig],
				data: {authorities: [TipoProfilo.ADMIN], breadcrumb: {label: 'regole', icon: 'mdi mdi-printer-pos-cog-outline'}}
			},
			{
				path: 'applicazioni/:app/funzionalita/know-how',
				loadComponent: () => import('./views/know-how/know-how.component').then(c => c.KnowHowComponent),
				canActivate: [AuthGuard],
				data: {
					authorities: [TipoProfilo.ADMIN], breadcrumb: {label: 'know_how', icon: 'mdi mdi-head-lightbulb-outline'}
				}
			},
			{
				path: 'applicazioni/:app/funzionalita/parametri-generali',
				loadComponent: () => import('./views/parametri-generali/parametri-generali.component').then(c => c.ParametriGeneraliComponent),
				canActivate: [AuthGuard],
				data: {
					authorities: [TipoProfilo.ADMIN], breadcrumb: {label: 'parametri_generali', icon: 'mdi mdi-tune-variant'}
				}
			},
			{
				path: 'user-profile',
				loadComponent: () => import('./views/user-profile/user-profile.component').then(c => c.UserProfileComponent),
				canActivate: [AuthGuard],
				data: {authorities: []}
			},
			{
				path: 'wallet-transactions',
				loadComponent: () => import('./views/wallet/wallet-transactions/wallet-transactions.component').then(c => c.WalletTransactionsComponent),
				canActivate: [AuthGuard],
				data: {authorities: []}
			},
      {
        path: 'wallet-provvigioni',
        loadComponent: () => import('./views/wallet/wallet-provvigioni/wallet-provvigioni.component').then(c => c.WalletProvvigioniComponent),
        canActivate: [AuthGuard],
        data: {authorities: []}
      },
      {
        path: 'wallet-admin',
        loadComponent: () => import('./views/wallet/wallet-admin/wallet-admin.component').then(c => c.WalletAdminComponent),
        canActivate: [AuthGuard],
        data: {authorities: [TipoProfilo.ADMIN]}
      },
      {
        path: 'wallet-listino',
        loadComponent: () => import('./views/wallet/wallet-listino/wallet-listino.component').then(c => c.WalletListinoComponent),
        canActivate: [AuthGuard],
        data: {authorities: []}
      },
			{
				path: 'applicazioni/:app/documenti',
				loadComponent: () => import('./views/documenti/documenti.component').then(c => c.DocumentiComponent),
				canActivate: [AuthGuard],
				data: {authorities: []}
			},
			// ROUTES DOMINIO:
			...configurazioneRoutes,
      {
        path: '**',
        redirectTo: 'applicazioni'
      }
		]
	}

];
